var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.items[0])?_c('ul',_vm._l((_vm.items),function(item,index){return _c('TreeListItem',{key:index,attrs:{"item":item,"hasChildrenField":_vm.hasChildrenField},on:{"select":(child) => _vm.$emit('select', child),"expand":(item) => _vm.$emit('expand', item),"userView":(user) => _vm.$emit('userView', user)}})}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }